import React from "react";
import AutoTyping, { BlinkCursor } from "react-auto-typing";

const KeyChallenges = () => {
  return (
    <div className="government-key-challanges-wrapper">
      <div className="section-title">
        <h1 className="title">Key Challenges</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Challenges"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 col-md-4">
          <div className="card">
            <div className="icon-container">
              <i className="fa-solid fa-compass"></i>
            </div>
            <h4 className="title">
              Managing public assets
              <br /> and resources efficiently
            </h4>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-4">
          <div className="card">
            <div className="icon-container">
              <i className="fa-solid fa-layer-group"></i>
            </div>
            <h4 className="title">
              Ensuring transparency <br /> and accountability in operations
            </h4>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-4">
          <div className="card">
            <div className="icon-container">
              <i className="fa-solid fa-diagram-predecessor"></i>
            </div>
            <h4 className="title">
              Safeguarding sensitive
              <br /> government data
            </h4>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-4">
          <div className="card">
            <div className="icon-container">
              <i className="fa-solid fa-industry"></i>
            </div>
            <h4 className="title">
              Streamlining payroll
              <br /> and HR processes
            </h4>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-4">
          <div className="card">
            <div className="icon-container">
              <i className="fa-solid fa-bug-slash"></i>
            </div>
            <h4 className="title">
              Enhancing public
              <br /> service delivery
            </h4>
          </div>
        </div>
        <div className="col-12 col-sm-6 col-md-4">
          <div className="card">
            <div className="icon-container">
              <i className="fa-solid fa-compass"></i>
            </div>
            <h4 className="title">
              Managing complex
              <br /> supply chains
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyChallenges;
